import { Button, Dialog, DialogContent, Link, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './account-required-modal.scss';
import { useDialogs } from '../../contexts/Dialog/DialogContext.tsx';
import { AuthDialog } from '../../views/auth-dialog/auth-dialog.tsx';

interface AccountRequiredModalProps {
  open: boolean;
  onClose: (value: boolean) => void;
}

export const AccountRequiredModal = ({
  open,
  onClose,
}: AccountRequiredModalProps) => {
  const dialogs = useDialogs();

  const login = () => {
    dialogs.open(AuthDialog, { payload: 'login' });
  };

  const createAccount = () => {
    dialogs.open(AuthDialog, { payload: 'auth' });
    onClose(false);
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <>
      <Dialog
        className="account-required-modal"
        open={open}
        onClose={() => void handleClose()}
      >
        <DialogContent className="container">
          <Button
            variant="transparent"
            className="close-btn"
            onClick={() => void handleClose()}
            sx={{ color: 'white' }}
          >
            <CloseIcon sx={{ fill: '#49454F' }} />
          </Button>
          <Typography className="title">Account Required</Typography>
          <Typography className="text">
            For access to this feature and other premium features, an account is
            required
          </Typography>
          <Button
            onClick={() => {
              createAccount();
            }}
            className="btn"
          >
            Create Account
          </Button>
          <Link
            data-testid="create-account-link"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '12px',
            }}
            onClick={() => login()}
            href="#"
            className="create-account-link"
          >
            Already have an account? Sign in here
          </Link>
        </DialogContent>
      </Dialog>
    </>
  );
};
